// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__aRQbZ","skeleton_animate":"skeleton_skeleton_animate__Gm3wo","small":"skeleton_small__WCCdZ"};